import { render, staticRenderFns } from "./Staff.vue?vue&type=template&id=a9a80e98&scoped=true"
import script from "./Staff.vue?vue&type=script&lang=js"
export * from "./Staff.vue?vue&type=script&lang=js"
import style0 from "./Staff.vue?vue&type=style&index=0&id=a9a80e98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a80e98",
  null
  
)

export default component.exports